// @flow

import PropTypes from 'prop-types';

export type VaseAnnotations = Array<string>;

export type PinJoinType = {
  visual_descriptions?: Array<string>,
  i18n_visual_descriptions?: Array<string>,
  visual_annotation?: VaseAnnotations,
};

export type PinType = any;

export type AnnotationWithLink = {
  name: string,
  url: string,
  path?: string,
  type?: string,
};

export type AnnotationsWithLinks = Array<AnnotationWithLink>;

export type HomePinType = {
  dominant_color: string,
  id: string,
  images: Object,
  pinner: Object,
  title: string,
};

export type HomeTopicType = {
  background_color: string,
  creation_time: number,
  enum_type: number,
  has_related: boolean,
  id: string,
  image_signature: string,
  image_size: number,
  image_source: string,
  is_followed: boolean,
  is_new: boolean,
  key: string,
  name: string,
  type: string,
  url_name: string,
};

export type HomeBoardType = {
  cover_images: Object,
  follower_count: number,
  id: string,
  image_cover_url: string,
  name: string,
  owner: Object,
  pin_count: number,
  pin_thumbnail_urls: Array<string>,
  url: string,
};

export type ContextType = {
  locale: string,
  isBot: boolean,
  pageType: string,
  unauthId: string,
  userAgent: {
    canUseNativeApp: boolean,
    isTablet: boolean,
    platform: string,
    platformVersion: Array<number>,
    raw: string,
    browserName: string,
  },
};

export type SrcSetType = {|
  oneXSizes: Array<string>,
  twoXSizes?: Array<string>,
  threeXSizes?: Array<string>,
|};

export const userPropTypeDefinition = {
  username: PropTypes.string,
  full_name: PropTypes.string,
};

export const defaultPinPropDefinition = {
  board: PropTypes.shape({
    image_thumbnail_url: PropTypes.string,
  }),
  buyable_product: PropTypes.shape({
    short_description: PropTypes.string,
    title: PropTypes.string,
  }),
  link_domain: PropTypes.shape({
    official_user: PropTypes.shape(userPropTypeDefinition),
  }),
  origin_pinner: PropTypes.shape(userPropTypeDefinition),
  pinner: PropTypes.shape({
    ...userPropTypeDefinition,
    image_medium_url: PropTypes.string,
    image_small_url: PropTypes.string,
  }),
  rich_metadata: PropTypes.shape({
    article: PropTypes.shape({
      name: PropTypes.string,
    }),
    link: PropTypes.string,
    name: PropTypes.string,
    offer_summary: PropTypes.shape({
      price: PropTypes.string,
    }),
    products: PropTypes.any,
    recipe: PropTypes.shape({
      from_aggregated_data: PropTypes.bool,
      name: PropTypes.string,
    }),
    site_name: PropTypes.string,
    title: PropTypes.string,
    tutorial: PropTypes.any,
  }),
};

export const pinPropType = PropTypes.shape({
  id: PropTypes.string,
  aggregated_pin_data: PropTypes.shape({
    aggregated_status: PropTypes.shape({
      likes: PropTypes.number,
      saves: PropTypes.number,
    }),
  }),
  attribution: PropTypes.shape({
    author_name: PropTypes.string,
    author_url: PropTypes.string,
    provider_favicon_url: PropTypes.string,
    provider_name: PropTypes.string,
    rich_site_name: PropTypes.string,
    url: PropTypes.string,
  }),
  board: PropTypes.shape({
    image_thumbnail_url: PropTypes.string,
    name: PropTypes.string,
    url: PropTypes.string,
  }),
  comment_count: PropTypes.number,
  description: PropTypes.string.isRequired,
  description_html: PropTypes.string.isRequired,
  domain: PropTypes.string.isRequired,
  dominant_color: PropTypes.string,
  fullImage: PropTypes.string,
  images: PropTypes.shape({
    '236x': PropTypes.shape({
      height: PropTypes.number.isRequired,
      width: PropTypes.number.isRequired,
      url: PropTypes.string.isRequired,
    }),
  }).isRequired,
  is_repin: PropTypes.bool,
  is_uploaded: PropTypes.bool,
  link: PropTypes.string,
  pin_join: PropTypes.shape({
    i18n_visual_descriptions: PropTypes.arrayOf(PropTypes.string),
    seo_description: PropTypes.string,
    visual_annotation: PropTypes.arrayOf(PropTypes.string),
    visual_descriptions: PropTypes.arrayOf(PropTypes.string),
  }),
  pinner: PropTypes.shape({
    image_small_url: PropTypes.string,
    full_name: PropTypes.string,
    username: PropTypes.string,
  }),
  place_summary: PropTypes.shape({
    name: PropTypes.string,
    source_icon: PropTypes.string,
    source_name: PropTypes.string,
  }),
  repin_count: PropTypes.number.isRequired,
  rich_summary: PropTypes.shape({
    apple_touch_icon_images: PropTypes.shape({
      orig: PropTypes.string.isRequired,
      '50x': PropTypes.string,
    }),
    display_name: PropTypes.string,
    favicon_images: PropTypes.shape({
      orig: PropTypes.string.isRequired,
      '50x': PropTypes.string,
    }),
    name: PropTypes.string,
    site_name: PropTypes.string,
  }),
  title: PropTypes.string.isRequired,
});

export const HTMLElementPropType = (props: ?Object, propName: string, componentName: string) => {
  if (!props || (props[propName] && !(props[propName] instanceof window.HTMLElement))) {
    return new Error(
      'Invalid prop `' + propName + '` supplied to `' + componentName + '`. Validation failed.',
    );
  }
  return undefined;
};
